@if (clientConfig(); as cfg) {
  <d2d-payment-recovery-banner />
  <section class="home">
    <div class="home__background" [style.backgroundImage]="'url(' + cfg.banner_url + ')'">
      <div class="home__container">
        <div class="home__contentTitles">
          <h1 class="home__title" [style.color]="cfg.main_title_color">
            {{ cfg.main_title }}
          </h1>
          <h2 class="home__subtitle" [style.color]="cfg.main_subtitle_color">
            {{ cfg.main_subtitle }}
          </h2>
        </div>
        <d2d-widget-search class="home__search" />
      </div>
    </div>
  </section>

  <section class="services">
    <d2d-waves [baseColor]="cfg.bg_color" />

    <div class="services__container">
      <div class="services__contentTitles">
        <h2 class="services__title">{{ 'home.services.title' | transloco }}</h2>
        <h3 class="services__subtitle">{{ 'home.services.subtitle' | transloco }}</h3>
      </div>
      <div class="services__contentCards">
        @for (service of services(); track $index) {
          <d2d-service-card [item]="service" [border]="$index % 2 === 0 ? 'primary' : 'oil'" />
        }
      </div>

      <button class="services__button" pButton size="large">
        {{ 'home.services.cta' | transloco }}
      </button>
    </div>
  </section>

  <section class="faq" id="faqs">
    <d2d-waves />

    <div class="faq__container">
      <div class="faq__contentTitles">
        <h2 class="faq__title">{{ 'home.faq.title' | transloco }}</h2>
        <h3 class="faq__subtitle">{{ 'home.faq.subtitle' | transloco }}</h3>
      </div>
      <div class="faq__accordion">
        <p-accordion
          [(value)]="activePanel"
          (valueChange)="onPanelChange($event ?? -1)"
          [multiple]="false"
        >
          @for (faq of faqs(); track $index) {
            <p-accordion-panel [value]="$index" class="mb-2">
              <p-accordion-header>
                <ng-template #toggleicon let-active="active">
                  <i class="pi" [ngClass]="active ? 'pi-chevron-up' : 'pi-chevron-down'"></i>
                </ng-template>
                <span>{{ faq.title }}</span>
              </p-accordion-header>

              <p-accordion-content>
                <div
                  id="faq-{{ $index }}"
                  class="m-0"
                  [innerHTML]="getSanitizedHTML(faq.description)"
                ></div>
              </p-accordion-content>
            </p-accordion-panel>
          }
        </p-accordion>
      </div>
    </div>
  </section>

  @if (cfg.slug === 'd2d') {
    <section class="partners">
      <d2d-waves baseColor="#B1802E" />
      <div class="partners__container">
        <div class="partners__contentTitles">
          <h2 class="partners__title">{{ 'home.partners.title' | transloco }}</h2>
          <h3 class="partners__subtitle">{{ 'home.partners.subtitle' | transloco }}</h3>
        </div>

        <!--
        <p-carousel
          [value]="affiliates"
          [numVisible]="3"
          [numScroll]="3"
          [circular]="true"
          [responsiveOptions]="responsiveOptions"
          class="partners__carousel"
        >
          <ng-template let-affiliate #item>
            <div class="partners__carouselItem">
              <img
                src="{{ affiliate.image }}"
                alt="{{ affiliate.name }}"
                title="{{ affiliate.name }}"
                class="partners__carouselImage"
              />
            </div>
          </ng-template>
        </p-carousel>
        -->

        @if (showSubscriberForm) {
          <d2d-subscriber-form class="partners__subscriberForm" />
        } @else {
          <button
            class="partners__button"
            pButton
            severity="contrast"
            size="large"
            (click)="showSubscriberForm = true"
          >
            {{ 'home.partners.cta' | transloco }}
          </button>
        }
      </div>
    </section>

    <section id="contact" class="contactUs">
      <d2d-waves />
      <div class="contactUs__container">
        <div class="contactUs__contentTitles">
          <h2 class="contactUs__title">{{ 'home.contact.title' | transloco }}</h2>
          <p class="contactUs__subtitle">{{ 'home.contact.paragraph1' | transloco }}</p>
          <p class="contactUs__subtitle">{{ 'home.contact.paragraph2' | transloco }}</p>
          <p class="contactUs__subtitle contactUs__subtitle--bold">
            {{ 'home.contact.paragraph3' | transloco }}
          </p>
          <ul class="contactUs__list">
            <li>
              <i class="pi pi-envelope text-primary"></i>
              <span>{{ 'soporte@d2d.team' }}</span>
            </li>
            <li>
              <i class="pi pi-phone text-primary"></i>
              <span>+09 876 5432</span>
            </li>
            <li>
              <i class="pi pi-globe text-primary"></i>
              <span>{{ 'home.contact.country' | transloco }}</span>
            </li>
          </ul>
        </div>
        <div class="contactUs__form">
          <d2d-contact-form />
        </div>
      </div>
    </section>
  }
}
